import { isEmpty } from 'lodash';
import DocCosignAutocomplete from 'vcomponents/documents/DocCosignAutocomplete.vue';
import { h, render } from 'vue';

window.YousignPrefs = {
	loadPrefs : function(){
		var formID = "ysPrefsForm";

		var options = {
			title	: Loc.g("Préférences Signature électronique"),
			width	: 900,
			buttons	:[
                {
                    text: Loc.g("Fermer"), class: 'btn btn-default', click : function(){MyWindow.close();}
                },
                {
                    html: Loc.g("Enregistrer"), class: 'btn btn-primary', click : function(){$('#'+formID).submit()}
				}
			],
			callback	: function(){
				var options = {
					data	: {action : 'record'},
					dataType: 'json',
					beforeSend : function(){
						$('#'+formID).find('.alert').remove();
					},
					success	: function (data) {
						var formOK = MyForm.processJson(data, data.form.formId);

						if(formOK){
							$('#'+formID).prepend('<div class="alert alert-success"><i class="fa fa-check" style="margin-right:5px;"></i> '+Loc.g('Vos préférences ont bien été enregistrées')+'</div>');
						}else{
							$('#'+formID).prepend('<div class="alert alert-danger"><i class="fa fa-exclamation-triangle" style="margin-right:5px;"></i> '+data.form.msg+'</div>');
						}
					},
				};
				MyForm.prepare(formID, "yousign_prefs", options, true);
				MyFacture.initEvent("#" + formID);
			},
		};

		MyWindow.load("yousign_prefs", {action : ""}, options);
	},
};


window.Esign = {

	activatePref : function(doctype, id) {
		const route = `/rest/documents/${doctype}/${id}/show-signature`
		$('.esign-document-alert__button').addClass('esign-document-alert__button--is-loading');
		window.SellsyJS.WebServiceCaller.patch(route, {}, {},
		() => {
			Utils.relocate(window.location.href.replace(/&tab=esign/g, '')+'&tab=esign');
		})
		.catch(error => {
			Push.error(Loc.g('Une erreur est survenue : ' + error));
		});
	},

	signForm : function(linkedtype, linkedid){

		if($('#docIsExpired').length > 0){

			MyWindow.alert(Loc.g("Les signatures électroniques ne sont pas applicables sur les documents expirés"), {type:'warning'});

		} else if(linkedtype == 'propdocument' && $('#canBeSigned').length > 0 && $('#canBeSigned').val() == 'N') {
			var opt = {
				title: Loc.g("Impossible d’activer la signature"),
				type: 'warning',
				buttons: [
				{
				    text: Loc.g("Fermer"),
				    click: function(){
				        $(this).dialog("close");
			        }
			    }
			]};

			var message = Loc.g("La signature électronique ne peut être activée car le document redactor ne contient pas de bloc destiné à la signature électronique.")
				+"<br/><br/>"+
				Loc.g("Éditez-le pour ajouter un bloc de type Signature.");

			MyWindow.alert(message, opt);

		} else {
			var formID = 'esignForm';

			var opts = {
				title : Loc.g('Demander une signature électronique'),
				width : 830,
				buttons : [
                    {
						text : Loc.g('Annuler'),
						click : function(){
							$(this).dialog('close');
						}
					},
                    {
						text :Loc.g('Envoyer'),
						disabled: $('#signatureHidden').length > 0,
						click : function(){
							Esign.presubmit(formID);
							$('#'+formID).submit();
						}
					}
				],
				callback : function(){
					MyFacture.customForm('#'+formID);

					var quota = isEmpty($('input[name=quota]').val()) ? null : $('input[name=quota]').val();

					var title = Loc.g('Demander une signature électronique')
							+ ' <span style="position:absolute;top:10px;right:40px;">'
							+ (quota === null || quota > 1 ? Loc.g('Signatures restantes') : Loc.g('Signature restante'))
							+ ' : '
							+ (quota !== null ? quota : Loc.g('Illimité'))
							+'</span>'
					;

					$('.ui-dialog-title').html(title);

					var opts = {
						data : {action : 'signFormRecord'},
						dataType : 'json',
						beforeSend : function(){
							$('#'+formID).find('.alert-danger').remove();
						},
						success : function(data){
							var formIsOk = MyForm.processJson(data, formID);

							if(formIsOk){
								MyWindow.close();
								Utils.relocate(window.location.href.replace(/&tab=esign/g, '')+'&tab=esign');
							}else{
								if(data.form.msg != ''){
									var $alert = $('<div class="alert alert-danger" style="padding-right:14px;"><i class="fa fa-exclamation-triangle" style="margin-right:5px;"></i> '+data.form.msg+'</div>');
									if(data.quotaAction != undefined){
										$alert.append('<a href="javascript:;" class="btn btn-success fright" onclick="'+data.quotaAction+'" style="margin-top:-5px;" ><i class="fa fa-shopping-cart"></i> '+Loc.g('Recharger le quota')+'</a>')
									}
									$alert.prependTo($('#'+formID));

								}
							}
						}
					};

					var inputId = $('input[name=contactId]').val(),
						inputPname = $('input[name=contactName]').val(),
						inputEmail = $('input[name=contactEmail]').val();

					if (inputId != '' && inputPname != '' && inputEmail != '') {
						Esign.addCosign({
							"id": inputId,
							"pname": inputPname,
							"pforename": $('input[name=contactForename]').val(),
							"email": inputEmail,
							"mobile": $('input[name=contactMobile]').val()
						});
					}

                    const autocompleteThirdid = $('#cosign-autocomplete').data('thirdid');
                    Esign.getComponentCoSignAutocomplete('cosign-autocomplete', autocompleteThirdid);
					MyForm.prepare(formID, 'yousign_esign', opts, true);
				}
			};
			MyWindow.load('yousign_esign', {action : 'signForm', linkedtype : linkedtype, linkedid : linkedid}, opts, true);
		}
	},

	presubmit : function(formID){
		var authMode	= $('#'+formID+' #authmode').val();
		if(authMode == 'sms'){
			$('#'+formID+' .cosign .cs_phone').each(function(){
				var country = $(this).intlTelInput("getSelectedCountryData");

				$(this).closest('.cosign').find('.cs_countryphone').val(country.iso2);
			});
		}
	},

	goToSign : function(){
		var opts = {
			title : "",
			width : 800,
			buttons : [
				{text : 'Annuler', click : function(){$(this).dialog('close');}},
			],
			callback : function(){
			}
		};

		MyWindow.load('yousign_esign', {action : 'signForm', linkedtype : linkedtype, linkedid : linkedid}, opts, true);
	},

	addCosign : function(item){
		if ($('.cosign').length >= 6) {
			Push.warning(Loc.g("6 signataires maximum"));
			return;
		}

		var $form = $('#esignForm');

		if(item.name == item.id){
			item.pname		= '';
			item.forename	= '';
			item.phone		= '';
			item.email		= item.name;
 		}

        var alreadyCosigner = false;
        $('#cosignList tr .cs_peopleid').each(function () {
            if ($(this).val() == item.id) {
                alreadyCosigner = true;
            }
        });


        if (alreadyCosigner) {
            EventBus.emit('cosign:alreadycosign', alreadyCosigner);
            return;
        }

		var key	= Math.ceil(Math.random() * 100)+(new Date().getTime())+Math.ceil(Math.random() * 100);

		var	$li = $('#cosignList tr.template').clone();
		$li.removeClass('template').addClass('cosign');

		$li.attr('id', 'cosign_'+key);

		$li.find('.name').text(item.name);
		$li.find('.email').text(item.email);

		$li.find('.cs_peopleid').attr('name', 'cosign['+key+'][peopleid]').attr('id', 'cosign_'+key+'_peopleid').val(item.id);
		$li.find('.cs_name').attr('name', 'cosign['+key+'][name]').attr('id', 'cosign_'+key+'_name').val(item.pname);
		$li.find('.cs_forename').attr('name', 'cosign['+key+'][forename]').attr('id', 'cosign_'+key+'_forename').val(item.pforename);

		$li.find('.cs_email').attr('name', 'cosign['+key+'][email]').attr('id', 'cosign_'+key+'_email').val(item.email);

		var $phone = $li.find('.cs_phone').addClass('e164Number').attr('name', 'cosign['+key+'][phone]').attr('id', 'cosign_'+key+'_phone');

        var defaultCountryCode = SmartPhoneNumber.getDefaultCountryCode($form);

        SmartPhoneNumber.prepareOneField($phone, SmartPhoneNumber.getPreferredCountries(defaultCountryCode), defaultCountryCode);

        if(item.mobile !== undefined){
            $phone.intlTelInput('setNumber', item.mobile);
        }

        $('.e164Country', $li).attr('name', 'cosign[' + key + '][phonecountry]').attr('id', 'cosign_' + key + '_phonecountry');

		$li.find('.deleteBtn').attr('onclick', 'Esign.deleteCosign("'+key+'")');

		$li.appendTo('#cosignList').fadeIn('fast');

		if($('#cosignList tr:not(#cosignList tr.template)').length > 0){
			$('.placeholder', $form).hide();
		}
	},

	deleteCosign : function(cosignID){
		$('#cosign_'+cosignID).fadeOut('fast', function(){
			$(this).remove();

			if($('#cosignList tr:not(#cosignList tr.template)').length == 0){
				$('#esignForm .placeholder').show();
			}
		});
	},


	// Docs
	loadDocTab: async function (esignID, linkedid, linkedtype, providerEsign) {
		let shouldRedirectToEsignPrefs = 0
		if (providerEsign === "docusign") {
			let result = await ApiClient.get('settings/esign/providers')
			shouldRedirectToEsignPrefs = result.data.provider.is_connected ? 0 : 1
		}

		var options = {
			action: "loadDocTab",
			esignID: esignID,
			linkedid: linkedid,
			linkedtype: linkedtype,
			shouldRedirectToEsignPrefs: shouldRedirectToEsignPrefs
		};
		MyFacture.post(
			'yousign_esign',
			options,
			function (data) {
				if (data.status === 'error') {
					window.Push.error(data.message);
				}
				$('#esign_content').html(data.esignOverview);
			},
			'json'
		);
	},


	notifyCosigners : function(esignID){

		if($('#docIsExpired').length > 0){

			MyWindow.alert(Loc.g("Les signatures électroniques ne sont pas applicables sur les documents expirés"), {type:'warning'});

		} else {

			var formID = 'esignForm';

			var opts = {
				title: Loc.g('Relancer les signataires'),
				width: 800,
				buttons: [{
						text: Loc.g('Annuler'), click: function () {
						$(this).dialog('close');
					}},{
					text: Loc.g('Enregistrer'), click: function () {
						Esign.presubmit(formID);
						$('#' + formID).submit();
					}}
				],
				callback: function () {

					MyFacture.customForm('#' + formID);

					var opts = {
						data: {
							action: 'notifyRecord',
							esignID: esignID
						},
						dataType: 'json',
						beforeSend: function () {
							$('#' + formID).find('.alert-danger').remove();
						},
						success: function (data) {
							var formIsOk = MyForm.processJson(data, formID);

							if (formIsOk) {
								MyWindow.close();
								MyWindow.alert(Loc.g('Les signataires ont bien été relancés'), {type: 'confirm'});
							} else if (data.form.msg != '') {
								$('#' + formID).prepend('<div class="alert alert-danger"><i class="fa fa-exclamation-triangle" style="margin-right:5px;"></i> ' + data.form.msg + '</div>');
							}
						}
					};

					MyForm.prepare(formID, 'yousign_esign', opts, true);
				}
			};

			MyWindow.load('yousign_esign', {action: 'notifyForm', esignID: esignID}, opts, true);
		}
	},

	cancel : function(esignID){

		var options = {
			buttons : [
				{
					text: Loc.g('Non'),
					'class'	: "btn btn-default",
					click : function(){
						$(this).dialog('close');
					}
				},
				{
					text: Loc.g('Oui'),
					'class'	: "btn btn-primary",
					click : function(){
						$(this).dialog('close');
						MyFacture.startWait();

						var params = {
							action	: 'cancelOne',
							esignID : esignID,
						};

						var callback = function(data){
							Utils.reload();
						}

						MyFacture.post('yousign_esign', params, callback, 'json');
					}
				}
			]
		}

		MyWindow.alert(Loc.g('Voulez-vous vraiment annuler cette signature électronique?'), options);
	},

    getComponentCoSignAutocomplete(container, thirdid, staffid) {
        const containerElement = document.getElementById(container)?.firstElementChild;
        if (containerElement) {
            const vnode = h(DocCosignAutocomplete, { thirdid, staffid });

            vnode.appContext = window.sellsyapp.appContext;
            render(vnode, containerElement);
        }
    },

};


window.PublicEsign = {
	gotoSign : function(url){
        document.location.href = url;
	}
};
